import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Button, ButtonType, CheckoutModal, Colors, RadioOptions} from '../components';
import './Cart.scss';
import {useAppStore, useColdStore} from '../data/AppStore';
import Signature from '../components/Signature';
import {getAdjustedPrice, getPrice, isValidEmail, logger} from '../utilities';
import CustomerService from '../api/customerService';
import {faCheck, faMinus, faPlus, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ClientInfo from './ClientInfo';
import Finish from './Finish';
import {loadPreviousCart} from '../helpers/loadPreviousCart';
import {checkIsOffline} from '../helpers/offlineHelper';
import {motion} from 'framer-motion';
import {shallow} from "zustand/shallow";
import ActionflowService from "../api/actionflowService";
import StoneAppService from "../api/stoneAppService";

const LOG_PREFIX = '[Cart.js]';

const Cart = () => {
    logger.silly(LOG_PREFIX, 'render');
    const [COMPANY, USER, OFFERINGS, RELATIONS, CART, CLIENT, setCART, OFFLINE, rectifyCART, setOFFLINE, cleanSTORE, setPREVIOUS_CLIENT] = useAppStore(
        (state) => [
            state.COMPANY,
            state.USER,
            state.OFFERINGS,
            state.RELATIONS,
            state.CART,
            state.CLIENT,
            state.setCART,
            state.OFFLINE,
            state.rectifyCART,
            state.setOFFLINE,
            state.cleanSTORE,
            state.setPREVIOUS_CLIENT,
        ], shallow
    )
    const [state, _setState] = useState({
        cartOptOut: false,
        sigOptOut: false,
        signature: null,
        saving: false,
        thanks: false,
        setup: false,
        loaded: false,
        currentDrawer: CART ? CART.accepted.length > 0 ? 3 : 4 : 4,
        checkoutModal: false
    });
    const setState = (newState) => _setState(Object.assign({}, state, newState));
    const {
        loaded,
        thanks,
        setup,
        checkoutModal,
        cartOptOut,
        sigOptOut,
        signature,
        saving,
        currentDrawer
    } = state;
    const [addCOLDSALES] = useColdStore((state) => [state.addCOLDSALES], shallow);
    useEffect(() => {
        setDrawer(CART.accepted.length > 0 ? 3 : 4)
    }, [CART])
    useEffect(() => {
        if (!loaded) {
            prepPreviousCart();
        }
    }, [CLIENT, COMPANY, loaded]);
    useEffect(() => {
        checkIsOffline().then((offline) => {
            if (offline !== OFFLINE) {
                logger.debug(LOG_PREFIX, '.checkOffline()', {message: `Changing Online/Offline State. App is offline? ${offline}.`});
                setOFFLINE(offline);
            }
        });
    }, [])
    const navigate = useNavigate();

    const prepPreviousCart = async () => {
        setState({loaded: true})
        const loadedCart = await loadPreviousCart(CART, COMPANY, CLIENT);
        if (loadedCart) {
            setCART(loadedCart);
        }
    }


    const hasDeclined = CART.declined && CART.declined.length >= 1;

    const handleFinishSubmit = async () => {
        logger.debug(LOG_PREFIX, '.handleFinishSubmit()');
        if (CLIENT.account && CLIENT.job && CLIENT.name && CLIENT.email && isValidEmail(CLIENT.email)) {
            setState({saving: true, setup: false, thanks: true, checkoutModal: false});
            logger.debug(LOG_PREFIX, '.handleFinishSubmit()', {CART, CLIENT, OFFERINGS, signature});
            try {
                const accounts = COMPANY && COMPANY.settings && COMPANY.settings.json_data && COMPANY.settings.json_data.accounts;

                // here we add the offerings on the cart object in place of just the id for accepted and declined
                // let adjustedCart = this.duplicateOfferings(cart, offerings);
                // we handle this on backend - because request is too large and throwing errors


                await CustomerService.saveSaleData({
                    cart: CART,
                    client: CLIENT,
                    offerings: OFFERINGS.map((o) => {
                        let slimOffering = Object.assign({}, o);
                        delete slimOffering.points; // hopefully this things up the data
                        delete slimOffering.images;
                        return {
                            ...slimOffering,
                            originalPrice: o.price,
                            price: getAdjustedPrice(o, CLIENT, COMPANY)
                        };
                    }),
                    signature,
                    accounts,
                }, (success, response) => {
                    console.log({response})
                    if (COMPANY.actionflow) {
                        ActionflowService.makeSendCSV(COMPANY.actionflow, response)
                    }
                    if (COMPANY.stoneApp) {
                        StoneAppService.postData(COMPANY.stoneApp, response)
                    }
                    setState({saving: false});
                    if (success) {
                        setPREVIOUS_CLIENT(CLIENT);
                        navigate('/finish', {replace: true});
                    }
                });
            } catch (error) {
                setState({saving: false, error});
                console.log(error);
            }
        } else {
            setState({setup: true});
        }
    }

    const handleFinishSubmitOffline = () => {
        logger.debug(LOG_PREFIX, '.handleFinishSubmit()');
        if (CLIENT.account && CLIENT.job && CLIENT.name && CLIENT.email && isValidEmail(CLIENT.email)) {
            setState({saving: true, setup: false, thanks: true, checkoutModal: false});
            logger.debug(LOG_PREFIX, '.handleFinishSubmit()', {CART, CLIENT, OFFERINGS, signature});
            // save to local storage
            setState({saving: false});
            addCOLDSALES({
                cart: CART,
                client: CLIENT,
                offerings: OFFERINGS.map((o) => {
                    let slimOffering = Object.assign({}, o);
                    delete slimOffering.points; // hopefully this things up the data
                    delete slimOffering.images;
                    return {
                        ...slimOffering,
                        originalPrice: o.price,
                        price: getAdjustedPrice(o, CLIENT, COMPANY)
                    };
                }),
                user: USER,
                signature,
                accounts: COMPANY && COMPANY.settings && COMPANY.settings.json_data && COMPANY.settings.json_data.accounts,
                date: new Date()
            })
            navigate('/finish', {replace: true});
        } else {
            setState({setup: true});
        }
    }

    const accordionTitle = (title, key, drawer, prev = true) => {
        return (
            <div
                onClick={() => (((CART[key].offerings && CART[key].offerings.length) || (CART[key].length > 0)) && setDrawer(drawer))}>
                <hr/>
                <div className={'accordionTitle'}>
                    <div>
                        <em>{title}</em>
                        <div>
                            <FontAwesomeIcon icon={(currentDrawer === drawer) ? faMinus : faPlus}/>
                        </div>
                        <em>{(prev) ?
                            ((CART[key] && CART[key].offerings && CART[key].offerings.length) || 0)
                            :
                            ((CART[key] && CART[key] && CART[key].length) || 0)
                        }</em>
                    </div>
                    <div>
                        <em>subtotal: {(key === 'accepted') ? getPrice(CART.total) : getPrice(CART[key].total)}</em>
                    </div>
                </div>
            </div>
        );
    };
    const accordionTitleDeclined = () => {
        return (
            <div onClick={() => (setDrawer(4))}>
                <hr/>
                <div className={'accordionTitle'}>
                    <div>
                        <em>Declined</em>
                        <div>
                            <FontAwesomeIcon icon={(currentDrawer === 4) ? faMinus : faPlus}/>
                        </div>
                        <em>{(CART.declined.length || 0)}</em>
                    </div>
                    <div/>
                </div>
            </div>
        );
    };

    const cartActions = {add: '+', remove: '-', set: '='};
    const setCartCount = (offering, action = cartActions.set, amount = 1, rectify = false) => {
        logger.debug(LOG_PREFIX, '.setCartCount()', {offering, amount});
        let cartClone = JSON.parse(JSON.stringify(CART));

        if (action === cartActions.add) {
            cartClone.quantity[offering.id] = (cartClone.quantity[offering.id]) ? parseInt(cartClone.quantity[offering.id]) + parseInt(amount) : parseInt(amount);
        } else if (action === cartActions.remove) {
            cartClone.quantity[offering.id] = (cartClone.quantity[offering.id]) ? parseInt(cartClone.quantity[offering.id]) - parseInt(amount) : 0;
        } else if (action === cartActions.set) {
            if (amount && amount >= 1) {
                cartClone.quantity[offering.id] = parseInt(amount);
            } else {
                cartClone.quantity[offering.id] = 0;
            }
        } else {
            // nothing
        }
        if (!rectify) {
            setCART(cartClone);
        } else {
            rectifyCART(cartClone);
        }
    }

    const togglePaidInCart = (offeringId) => {
        logger.debug(LOG_PREFIX, '.togglePaidInCart()', {offeringId});
        let cartClone = JSON.parse(JSON.stringify(CART));
        if (!cartClone.paid) {
            cartClone.paid = [];
        }
        if (cartClone.paid.indexOf(offeringId) === -1) {
            cartClone.paid.push(offeringId);
        } else {
            cartClone.paid = cartClone.paid.filter(x => x !== offeringId);
        }
        // setCART(CART);
        rectifyCART(cartClone);
    }


    const buildItem = (o, idx, accepted = true, previous = false, purchased = false) => {
        // logger.debug(LOG_PREFIX, '.buildItem()', { props: this.props, state: this.state, o, idx, accepted, previous });

        return (
            <div className={'item-wrapper'} key={o.id}>
                <div className={`Cart-item ${idx % 2 === 0 ? 'even' : 'odd'}`}>
                    <Link className={'Cart-item-title'} to={`/offering/${o.id}`}>
                        {o.sales_option}
                    </Link>

                    <div className={'Cart-item-price'}>
                        {!previous && `${getPrice(getAdjustedPrice(o, CLIENT, COMPANY))} (${o.unit_type})`}
                    </div>

                    <div className={`Cart-item-qty ${accepted ? '' : 'hidden'}`}>
                        <input
                            type={'number'}
                            value={previous && !purchased ? CART.previously_accepted.quantity[o.id] : (purchased) ? parseInt(CART.previously_purchased.quantity[o.id]) : parseInt(CART.quantity[o.id])}
                            onChange={(e) => {
                                setCartCount(o, cartActions.set, e.target.value);
                            }}
                            disabled={previous}
                            onBlur={() => {
                                console.log('blurring')
                                setCartCount(o, null, null, true)
                            }}
                            onFocus={e => e.target.select()}
                        />

                    </div>

                    <div className={'Cart-item-edit'}>
                        {!previous ? (
                            <>
                                <div className={'Cart-item-edit-button'}
                                     onClick={() => setCartCount(o, cartActions.add, 1, true)}>
                                    <FontAwesomeIcon className='Cart-item-edit-icon' icon={faPlus}/></div>
                                <div className={`Cart-item-edit-button ${accepted ? '' : 'hidden'}`}
                                     onClick={() => setCartCount(o, cartActions.remove, 1, true)}><FontAwesomeIcon
                                    className='Cart-item-edit-icon' icon={faMinus}/></div>
                                <div className={`Cart-item-edit-button ${accepted ? '' : 'hidden'}`}
                                     onClick={() => setCartCount(o, cartActions.remove, null, true)}><FontAwesomeIcon
                                    className='Cart-item-edit-icon' icon={faTrashAlt}/></div>
                            </>
                        ) : (
                            <>
                                <div className={'Cart-item-edit-button disabled'}><FontAwesomeIcon
                                    className='Cart-item-edit-icon' icon={faPlus}/></div>
                                <div className={'Cart-item-edit-button disabled'}><FontAwesomeIcon
                                    className='Cart-item-edit-icon' icon={faMinus}/></div>
                                <div className={'Cart-item-edit-button disabled'}><FontAwesomeIcon
                                    className='Cart-item-edit-icon' icon={faTrashAlt}/></div>
                            </>
                        )}
                    </div>
                </div>
                {!previous && accepted &&
                    <form key={o.id}>
                        <RadioOptions
                            onChange={(e) => {
                                togglePaidInCart(o.id, e);
                            }}
                            className={'paid-toggle'}
                            name={(CART && CART.paid && CART.paid.indexOf(o.id) >= 0) ? 'paid' : 'not'}
                            uniq={o.id}
                            options={[{label: 'Not Paid', value: 'not'}, {label: 'Paid', value: 'paid'}]}
                        />
                    </form>
                }
            </div>
        );
    }

    // todo -- check this
    const hideParentOfferings = (itemList) => {
        logger.debug(LOG_PREFIX, '.hideParentOfferings()', {itemList});
        return itemList;

        // logger.debug(LOG_PREFIX, '.hideParentOfferings()', {itemList});
        // let offerings = AppStore.getOfferings();
        // let relations = generateRelations(offerings);
        // offerings = offerings.map(o => ({...o, immediateChildren: getImmediateChildren(o, offerings, relations)}));
        // logger.debug(LOG_PREFIX, '.hideParentOfferings()', {offerings});
        // let declinedOfferings = offerings.filter(o => itemList.map(i => i.id).includes(o.id));
        // logger.debug(LOG_PREFIX, '.hideParentOfferings()', {declinedOfferings});
        // const declinedPricedOfferings = declinedOfferings.filter(o => {
        //     if (o.immediateChildren && o.immediateChildren.items) {
        //         return !(o.immediateChildren.items.length >= 1);
        //     } else {
        //         return true;
        //     }
        // });
        // logger.debug(LOG_PREFIX, '.hideParentOfferings()', {declinedPricedOfferings});
        // return declinedPricedOfferings;
    }

    const setDrawer = (d) => {
        logger.debug(LOG_PREFIX, '.setDrawer()', {d});
        if (currentDrawer !== d) {
            setState({currentDrawer: d});
        }
    }

    if (thanks) {
        return (<Finish saving={true}/>);
    }

    if (setup) {
        return (<ClientInfo cart={true} checkout={handleFinishSubmit}/>);
    }

    const drawerStyle = [
        'min-content auto min-content 0 min-content 0 min-content 0 min-content / 1fr',
        'min-content 0 min-content auto min-content 0 min-content 0 min-content / 1fr',
        'min-content 0 min-content 0 min-content auto min-content 0 min-content / 1fr',
        'min-content 0 min-content 0 min-content 0 min-content auto min-content / 1fr'];

    return (
        <div className={'Cart'}>

            {checkoutModal &&
                <CheckoutModal toggleClosed={() => setState({checkoutModal: false})}>
                    <>
                        <div className={'Cart-opt-out'}>
                            {hasDeclined && (

                                <label className='input-label'>
                                    <div>
                                        {'By checking this box, you agree to opt-out of the offers which have NOT been added to your cart. '}
                                    </div>
                                    <input className='input' type='checkbox' checked={cartOptOut} onChange={(e) => {
                                        setState({cartOptOut: e.target.checked});
                                    }}/>
                                    <div className='checkbox-icon'>
                                        <FontAwesomeIcon icon={faMinus}/>
                                        <FontAwesomeIcon icon={faCheck}/>
                                    </div>
                                </label>
                            )}
                        </div>
                        <div className={'Sig-opt-out'}>
                            <label className='input-label'>
                                <div>
                                    {'As the company representative, I have the Customer’s verbal approval to finalize this purchase'}
                                </div>
                                <input className='input' type='checkbox' checked={sigOptOut} onChange={(e) => {
                                    setState({sigOptOut: e.target.checked});
                                }}/>
                                <div className='checkbox-icon'>
                                    <FontAwesomeIcon icon={faMinus}/>
                                    <FontAwesomeIcon icon={faCheck}/>
                                </div>
                            </label>

                            {OFFLINE &&
                                <label className='input-label'>
                                    <div>
                                        <br/>The app is currently offline, so the cart will checkout when the
                                        application connects back online
                                    </div>
                                </label>
                            }
                        </div>
                        <div className={'cart-summary'}>
                            {((CART.previously_accepted || CART.previously_accepted.offerings || CART.previously_accepted.offerings.length > 0) || (CART.total > 0)) && (
                                <>
                                    <h3>Order Summary:</h3>
                                    <div>
                                        <p>Previously Approved Subtotal: </p>
                                        <h3>{getPrice((CART.previously_accepted.total || 0))}</h3>
                                        <p>Currently Selected Subtotal:</p> <h3>{getPrice(CART.total)}</h3>
                                        <hr className={'hr'}/>
                                        <h3>Total:</h3>
                                        <h3>{getPrice(CART.total + (CART.previously_accepted.total || 0))}</h3>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className={'cart-signature'}>
                            <Signature
                                signature={signature}
                                setSignature={(s) => {
                                    setState({signature: s});
                                }}
                                optout={sigOptOut}
                                label={(
                                    <div className={'Cart-section-header'}>
                                        <h3>Signature:</h3>
                                        <p><em>Client:</em> {CLIENT.name}</p>
                                        <p><em>Client Email:</em> {CLIENT.email}</p>
                                    </div>
                                )}>
                                <Button
                                    label={'Finalize Cart'}
                                    disabled={saving || (!cartOptOut && hasDeclined) || !signature}
                                    onClick={OFFLINE ? handleFinishSubmitOffline : handleFinishSubmit}
                                    type={ButtonType.Save}
                                    colorTheme={Colors.Green}
                                />
                            </Signature>
                        </div>
                    </>
                </CheckoutModal>
            }

            <div className={'Cart-navigation'}>
                <h2>{COMPANY.name}</h2>
                <Button
                    type={ButtonType.Backward}
                    colorTheme={Colors.Orange}
                    onClick={() => navigate(`/offering/${OFFERINGS[0].id}`, {replace: true})}
                    label='Back'
                />
            </div>
            <div
                className={'Cart-container'}
                style={{
                    grid: drawerStyle[currentDrawer - 1]
                }}
            >

                {accordionTitle('Previously Purchased', 'previously_purchased', 1)}
                <motion.div
                    style={{height: (currentDrawer === 1) ? 'initial' : '0'}}
                >
                    <div className={'Cart-offerings-previously-purchased accordionList'}>
                        {(CART.previously_purchased && CART.previously_purchased.offerings && CART.previously_purchased.offerings.length > 0) ?
                            CART.previously_purchased.offerings.map((o, idx) => {
                                return buildItem(o, idx, true, true, true);
                            }) : null
                        }
                    </div>
                </motion.div>

                {accordionTitle('Previously Accepted', 'previously_accepted', 2)}
                <motion.div
                    style={{height: (currentDrawer === 2) ? 'initial' : '0'}}
                >
                    <div className={'Cart-offerings-previously-accepted accordionList'}>
                        {(CART.previously_accepted && CART.previously_accepted.offerings && CART.previously_accepted.offerings.length > 0) ?
                            CART.previously_accepted.offerings.map((o, idx) => {
                                return buildItem(o, idx, true, true);
                            }) : null}
                    </div>
                </motion.div>

                {accordionTitle('Currently Selected', 'accepted', 3, false)}
                <motion.div
                    style={{height: (currentDrawer === 3) ? 'initial' : '0'}}
                    className={'Cart-offerings-accepted accordionList'}
                >
                    {(CART.accepted && CART.accepted.length >= 1) ?
                        OFFERINGS.filter((o) => (CART.accepted.map((a) => a.id).includes(o.id))).map((o, idx) => {
                            return buildItem(o, idx, true);
                        }) : null}
                </motion.div>

                {accordionTitleDeclined()}
                <motion.div
                    style={{height: (currentDrawer === 4) ? 'initial' : '0'}}
                >
                    <div className={'Cart-offerings-rejected accordionList'}>
                        {(CART.declined && CART.declined.length >= 1) && hideParentOfferings(OFFERINGS.filter((o) => (CART.declined.map((a) => a.id).includes(o.id)))).map((o, idx) => {
                            return buildItem(o, idx, false);
                        })}
                    </div>
                </motion.div>
            </div>
            <Button
                type={ButtonType.Download}
                colorTheme={Colors.Orange}
                label={'Checkout'}
                onClick={() => (
                    setState({checkoutModal: true})
                )}
            />
        </div>
    );
}

export default Cart;